import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PaymentForm from "@/components/PaymentForm";

export default function PaymentPage() {
  const nav = useNavigate();
  const location = useLocation();
  const { invoiceId, customerId } = location.state || {};

  const handleClose = () => {
    nav(-1);
  };

  const handleSuccess = () => {
    nav(-1);
  };

  return (
    <PaymentForm
      onClose={handleClose}
      onSuccess={handleSuccess}
      invoiceId={invoiceId}
      customerId={customerId}
    />
  );
}